import { faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ModalOpenButton } from "@msys/ui";
import { Add as AddIcon } from "@mui/icons-material";
import { Button, Icon } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { ImportViaDatanormOnlineModal } from "../ImportViaDatanormOnlineModal.js";

export interface DatanormOnlineAvailabilityInfo {
  clientIdRequired: boolean;
  usernameRequired: boolean;
  passwordRequired: boolean;
}

export const AddDatanormOnlineImportationButton = ({
  supplierId,
  itekCompanyId,
  availability,
  refetchQueries,
  appearance = "header",
}: {
  supplierId: string;
  itekCompanyId: string;
  availability: DatanormOnlineAvailabilityInfo;
  refetchQueries?: string[];
  appearance?: "header" | "cta";
}) => {
  const { t } = useTranslate(["PimImportations", "Global"]);

  const label = t("Sync via Datanorm", { ns: "PimImportations" });

  return (
    <ModalOpenButton
      Modal={ImportViaDatanormOnlineModal}
      modalProps={{
        supplierId,
        itekCompanyId,
        datanormOnlineInfo: availability,
        refetchQueries,
      }}
    >
      {appearance === "cta" ? (
        <Button color="primary" variant="text" startIcon={<AddIcon />}>
          {label}
        </Button>
      ) : (
        <Button
          color="primary"
          variant="contained"
          size="small"
          startIcon={
            <Icon>
              <FontAwesomeIcon icon={faCloudDownloadAlt} />
            </Icon>
          }
        >
          {label}
        </Button>
      )}
    </ModalOpenButton>
  );
};
